import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const HearIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.99902 12.3703V6.00098C2.99902 3.23955 5.2376 1.00098 7.99902 1.00098H8.40011C10.94 1.00098 12.999 3.05998 12.999 5.59989C12.999 7.41618 11.3226 8.58969 9.82571 9.63757C9.79056 9.66218 9.75551 9.68672 9.72058 9.71119C9.70199 9.72422 9.68369 9.73748 9.66569 9.75098C9.11281 10.1656 8.85338 10.8829 8.75355 11.6564C8.53448 13.3538 7.34115 15.001 5.62971 15.001C4.17682 15.001 2.99902 13.8232 2.99902 12.3703ZM11.3487 6.03049C11.48 3.40386 8.64446 1.67963 6.3728 3.00476L5.64248 3.43079C4.87273 3.8798 4.39941 4.70387 4.39941 5.595V6.63096C4.39941 7.44258 5.05736 8.10053 5.86898 8.10053H5.99941C6.22033 8.10053 6.39941 8.27961 6.39941 8.50053C6.39941 8.72144 6.22033 8.90053 5.99941 8.90053H5.86898C5.05736 8.90053 4.39941 9.55848 4.39941 10.3701V12.5005C4.39941 12.8319 4.66804 13.1005 4.99941 13.1005C5.33079 13.1005 5.59941 12.8319 5.59941 12.5005V10.3701C5.59941 10.2212 5.7201 10.1005 5.86898 10.1005H5.99941C6.88307 10.1005 7.59941 9.38418 7.59941 8.50053C7.59941 7.61687 6.88307 6.90053 5.99941 6.90053H5.86898C5.7201 6.90053 5.59941 6.77984 5.59941 6.63096V5.595C5.59941 5.13067 5.84604 4.70128 6.24712 4.46732L6.97745 4.0413C8.42591 3.19636 10.2339 4.29577 10.1502 5.97057C10.1336 6.30152 10.3885 6.58323 10.7195 6.59978C11.0504 6.61633 11.3321 6.36145 11.3487 6.03049Z"
		></path>
	</svg>
))
